export default () => ({
  isLoading: false,
  cartIsLoading: false,
  productIsLoading: false,
  cartTotal: 0,
  qty: 1,
  cartIsOpen: false,
  /* cartItemsQuantity: 0,*/
  cartAllItemsQuantity: 0,
  generalItems: [],
  generalItemsQuantity: 0,
  lineItemQuantity: 0,
  inventoryQuantity: 0,
  currentProductVariantId: null,
  firstAvailableVariant: null,
  addToCartButtons: null,
  productPageWarningText: null,
  finalPricesArray: [],
  currencySymbol: null,
  currentProductAvailableQuantity: 0,
  mainProduct: null,
  body: null,
  cartItems: [],
  freeProductId: null,
  init() {
    this.body = document.querySelector("body");
    this.finalPricesArray =
      JSON.parse(localStorage.getItem("finalPrice")) || [];
    this.mainProduct = document.querySelector("[data-main-product]");

    if (document.querySelector("[data-variants]")) {
      const variantsJSON = document.querySelector("[data-variants]").innerHTML;
      if (variantsJSON) {
        this.firstAvailableVariant =
          JSON.parse(variantsJSON).firstAvailableVariant;
      }
    }

    if (document.getElementById("MainContent")) {
      this.currencySymbol = document
        .getElementById("MainContent")
        .getAttribute("data-currency-symbol");
    }
    if (document.getElementById("main-product")) {
      this.inventoryQuantity = document
        .getElementById("main-product")
        .getAttribute("data-inventory");
      this.currentProductVariantId = document
        .getElementById("main-product")
        .getAttribute("data-variant-id");
      this.addToCartButtons = document.querySelectorAll(
        'button[type="submit"]'
      );
      this.productPageWarningText = document.querySelector(".max-qty__message");
    }
    this.getCardItems();
  },
  async add(event, section) {
    this.productIsLoading = true;
    let formData = "";
    let contentType = "";
    const form = event.currentTarget.closest("form");
    let freeItem = document.getElementById("free_product");
    const drawer = document.querySelector("psn-cart-drawer");
    const sectionId = drawer?.dataset.sectionId || section;

    // Open on the click, not on the response. The cart mutation takes about a
    // second on this store, and leaving the customer staring at an inert button
    // is what the slowness complaint was really about. The drawer shows a
    // loading state until the section refresh lands. See PS001R-909.
    if (drawer) {
      document.dispatchEvent(
        new CustomEvent("cart:open", {
          bubbles: true,
          detail: { optimistic: true },
        })
      );
    }
 
    if (freeItem) {
      if (freeItem.value !== "") {
        this.freeProductId = freeItem.value;
      }
    }
    formData = new FormData(form);
    formData.set("sections", sectionId);

    if (
      this.qty >= this.currentProductAvailableQuantity &&
      this.currentProductAvailableQuantity !== 0
    ) {
      this.qty = this.currentProductAvailableQuantity;
      formData.set("quantity", this.qty);
    }

    // Only pay for a cart read when a free gift might need appending — the
    // response feeds the alreadyInCart check alone. Skipping it lets
    // /cart/add.js claim Shopify's per-cart-token queue slot first.
    if (this.freeProductId) {
      await this.checkCardItems();
      const alreadyInCart = this.generalItems.some(
        (item) => Number(item.id) === Number(this.freeProductId)
      );
      if (!alreadyInCart) {
        formData.append("items[][id]", this.freeProductId);
        formData.append("items[][quantity]", "1");
      }
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers:
        contentType !== ""
          ? {
              "Content-Type": contentType,
            }
          : {},
      body: formData,
    })
      .then((response) => {
        if (response.status === 200 || response.status === 422) {
          return response.json();
        }
      })
      .then(async (data) => {
        if (data && !data.status) {
          const sectionHtml = data.sections?.[sectionId];
          // /cart/add.js returns the line item (qty added), not the cart. The
          // drawer section embeds the full cart as JSON, so read it from the
          // section render we already have. Falling back to /cart.js only when
          // that is unavailable (no drawer on the page, or a parse failure).
          const cartData =
            (data.total_price ? data : this.parseCartFromSection(sectionHtml)) ??
            (await fetch("/cart.js")
              .then((r) => r.json())
              .catch(() => null));
          const itemCount = cartData?.item_count ?? 0;
          if (sectionHtml && drawer) {
            document.dispatchEvent(
              new CustomEvent("cart:update", {
                bubbles: true,
                detail: {
                  cart: cartData,
                  itemCount,
                  sections: data.sections,
                  source: "psn-cart",
                },
              })
            );
          } else if (sectionHtml) {
            this.renderFromResponse(sectionHtml);
          }
          this.syncCartState(cartData);
          this.openMiniCart();
          document.dispatchEvent(
            new CustomEvent("cart:add", {
              bubbles: true,
              // `data` is the line item /cart/add.js echoes back — passed on so
              // analytics listeners get the added product without a refetch.
              detail: { itemCount, cart: cartData, item: data },
            })
          );
          // Only re-assert open if the drawer is still open. It was already
          // opened optimistically on the click, and ~900ms have passed since —
          // enough for the customer to dismiss it. Re-opening here would either
          // slide it back over the page or, if it caught the closing animation,
          // leave state.isOpen true on a closed dialog and wedge the cart icon.
          // The !drawer branch keeps the old behaviour for pages without one.
          if (!drawer || drawer.state?.isOpen) {
            document.dispatchEvent(new CustomEvent("cart:open", { bubbles: true }));
          }
        } else {
          // 422 (sold out, quantity limits) or an unexpected status — nothing
          // was added, so roll back the optimistic open.
          drawer?.cancelOptimisticOpen?.();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        drawer?.cancelOptimisticOpen?.();
      })
      .finally(() => {
        // Released here, not inside the .then — a 5xx or a network failure
        // used to leave the button spinner stuck forever. Same reasoning for
        // the drawer's loading state: onCartUpdate only clears it when a
        // section render came back, so clear it unconditionally too.
        this.productIsLoading = false;
        drawer?.clearOptimisticState?.();
      });
  },
  remove() {
    this.isLoading = true;
    alert("cart.remove");

    setTimeout(() => {
      this.isLoading = false;
    }, 2000);
  },
  async change(index, quantity, section, id) {
    this.cartIsLoading = true;

    try {
      const res = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          updates: { [index]: quantity },
          sections: section,
        }),
      });

      this.cartIsLoading = false;
      if (res.status !== 200 && res.status !== 422) return;
      const data = await res.json();
      if (!data) return;

      this.cartAllItemsQuantity = data.item_count;
      this.lineItemQuantity = data.quantity || 0;
      this.renderFromResponse(data.sections[section]);
      await this.getCardItems(id, quantity);

      const freeItemId = this.freeProductId;
      console.log("freeItemId", freeItemId);
      if (!freeItemId) return;

      const cart = await fetch("/cart.js").then((r) => r.json());

      const hasMainProduct = cart.items.some(
        (item) => item.properties && item.properties._has_free === "true"
      );

      const freeItemInCart = cart.items.find(
        (item) => Number(item.id) === Number(freeItemId)
      );

      if (freeItemInCart && !hasMainProduct) {
        console.log("Removing free item by key:", freeItemInCart.key);

        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            line: freeItemInCart.key,
            quantity: 0,
          }),
        });

        await this.getCardItems();
      }
    } catch (error) {
      console.error("Error:", error);
      this.cartIsLoading = false;
    }
  },
  renderFromResponse(section) {
    const cartItemsMain = document.querySelector(".cart-inner__wrapper");
    const parsed = new DOMParser().parseFromString(section, "text/html");
    const cartItemsWrapperHTML = parsed.querySelector(
      ".cart-inner__wrapper"
    )?.innerHTML;
    if (cartItemsWrapperHTML) {
      cartItemsMain.innerHTML = cartItemsWrapperHTML;
    }
  },
  openMiniCart() {
    this.cartIsOpen = true;
  },
  closeMiniCart() {
    this.cartIsOpen = false;
  },
  async getCardItems(id = null, quantity) {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        this.cartAllItemsQuantity = data.item_count;
        this.showHideFeaturedProductsOnCartPage();
        this.generalItemsQuantity = data.item_count;
        this.generalItems = data.items;
        this.cartTotal = data.total_price;
      });
  },
  // Reads the cart JSON embedded in the drawer section render, so an add can
  // resolve the full cart without a second /cart.js call. Mirrors
  // PsnCartDrawer.#parseCartState in assets/psn-cart-drawer.js.
  parseCartFromSection(html) {
    if (!html) return null;
    try {
      const fragment = new DOMParser().parseFromString(html, "text/html");
      const node = fragment.querySelector('[data-ref="cartState"]');
      return node ? JSON.parse(node.textContent) : null;
    } catch (error) {
      return null;
    }
  },
  // Mirror of getCardItems() without the round trip — by this point cartData
  // is already a full cart object.
  syncCartState(cart) {
    if (!cart) return;
    this.cartAllItemsQuantity = cart.item_count;
    this.generalItemsQuantity = cart.item_count;
    this.generalItems = cart.items || [];
    this.cartTotal = cart.total_price;
    this.showHideFeaturedProductsOnCartPage();
  },
  async checkCardItems() {
    const response = await fetch("/cart.js");
    const data = await response.json();
    this.generalItems = data.items;
    return data.items;
  },
  manipulateAmount(inputString, multiplier, symbol) {
    const initialAmount = parseFloat(inputString.replace(/[^\d.]/g, ""));
    if (isNaN(initialAmount)) {
      return "Invalid input format. Please provide a valid amount.";
    }

    const result = initialAmount * multiplier;

    return `${symbol}${result.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  },
  showHideFeaturedProductsOnCartPage() {
    const featuredProducts = document.querySelector(".collections-image-cards");

    if (featuredProducts) {
      if (this.cartAllItemsQuantity === 0) {
        featuredProducts.classList.remove("hidden");
      } else {
        featuredProducts.classList.add("hidden");
      }
    }
  },
});